module.controller('sampleInterpretSelectCtrl', [ '$compile', '$scope', '$rootScope', '$state', 'planSamplingService', 'dateUtilService', sampleInterpretSelectCtrlFn ]);
function sampleInterpretSelectCtrlFn($compile, $scope, $rootScope, $state, planSamplingService, dateUtil) {
	var vm = $scope;

	/*
	 * Muestras para ser analizadas
	 */
	vm.samplesToBeInterpreted = [];
	
	vm.showFiltersSamples = false;
	
	vm.isCollapsed = true;
	
	/*
	 * Filtro para que solo se admitan selecionar clientes activos
	 */
	vm.clientCustomFilter = {
		active : true
	};
	/*
	 * definiciones de filtros
	 */
	vm.filter = {
		client : {},
		planSampling : {},
		site : {},
		datePicker : {},
		idSample : {}
	};
	/*
	 * Muestras dispobibles
	 */
	vm.samples = {
		items : [],
		dragging : false
	};
	/*
	 * Muestars seleccionadas
	 */
	vm.samplesSelected = {
		items : [],
		dragging : false
	};
	/*
	 * se esta haciendo drag an drop
	 */
	vm.isDragging = false;
	/*
	 * opciones del qtip
	 */
	vm.opcionesQTip = {
		position : {
			my : 'top right', // Position my top left...
			at : 'bottom right',
			target : 'mouse',
			adjust : {
				x : 5,
				y : 5
			},
		},
		show : {
			delay : 500
		}
	};
	/*
	 * Opciones del datepicker
	 */
	vm.optsDatepicker = {
		locale : {
			applyClass : 'btn-green',
			applyLabel : "Elegir",
			fromLabel : "desde",
			format : "YYYY-MM-DD",
			toLabel : "a",
			cancelLabel : 'Cancelar',
			customRangeLabel : 'Personalizado'
		},
		ranges : {
			'Sin fecha' : [ '', '' ],
			'Últimos 7 dias' : [ moment().subtract(6, 'days'), moment() ],
			'Últimos 30 dias' : [ moment().subtract(29, 'days'), moment() ],
			'Este mes' : [ moment().startOf('month'), moment().endOf('month') ],
			'Próximos 7 dias' : [ moment(), moment().add(6, 'days') ],
			'Próximos 30 dias' : [ moment(), moment().add(29, 'days') ],
		},
		autoApply : true,
		eventHandlers : {
			'apply.daterangepicker' : onApplyDatePicker
		},
		dateLimit : {
			month : 2
		}
	};
	/*
	 * si cambia el cliente borra los camopos asociados de plan, punto,
	 * muestrass
	 */
	vm.onClientChange = function(client) {
		if (vm.filter.client.selected.length <= 0) {
			vm.filter.site = {};
			vm.filter.planSampling = {};
			vm.filter.idSample = {};
		}
		searchSamples();
	}
	/*
	 * si cambia el filtro de plan de muestreo
	 */
	vm.onPlanChange = function(plan) {
		searchSamples();
	}
	/*
	 * si cambia el filtro de sitio
	 */
	vm.onSiteChange = function(site) {
		searchSamples();
	}
	/*
	 * si cambia el filtro de id de la muestra
	 */
	vm.onIdSampleChange = function(idSample) {
		searchSamples();
	}
	/**
	 * Eventos Datepicker
	 */
	function onApplyDatePicker(ev, picker) {
		searchSamples();
	}
		
	vm.checkObservation= function(data, report) {
		vm.loading = true;
		var d = $q.defer();
		var filter = {};
		filter.existInvoiceNumber = data;
		ReportService.searchReports(filter).then(function(res) {		
			vm.loading = false;
			res = res || {};

			var responseData = res.getData();
			if(responseData.results.length > 0)
			{
				d.reject('ya existe');
			}else{
				 d.resolve();
			}
		}, function(res) {
			vm.loading = false;
			d.reject(' ');
		});
		return d.promise;
	};

	/*
	 * ejecuta la búsqueda de las muestras con los filtros especificados
	 */
	function searchSamples() {
		var filters = {};
		// filtro por idSAmple
		if (!isEmpty(vm.filter.idSample) && !isEmpty(vm.filter.idSample.selected)) {
			filters.idSample = vm.filter.idSample.selected[0];
		}
		// filtro por cliente
		if (!isEmpty(vm.filter.client) && !isEmpty(vm.filter.client.selected)) {
			filters.client = vm.filter.client.selected[0].id;
		}
		// filtro por plan
		if (!isEmpty(vm.filter.planSampling) && !isEmpty(vm.filter.planSampling.selected)) {
			filters.planSampling = vm.filter.planSampling.selected[0].id;
		}
		// si no esta definido alguno de los filtro obligatorios no hace la
		// búsqueda
		if (angular.isUndefined(filters.client) || angular.isUndefined(filters.planSampling)) {
			vm.samples.items = [];
			vm.showFiltersSamples = false;
			return;
		}
		// filtro por sitio
		if (!isEmpty(vm.filter.site) && !isEmpty(vm.filter.site.selected)) {
			filters.site = vm.filter.site.selected[0].id;
		}
		// fecha de toma de muestra
		if (!isEmpty(vm.filter.datePicker)) {
			if (vm.filter.datePicker.startDate.isValid() && vm.filter.datePicker.endDate.isValid()) {
				vm.filter.datePicker.startDate.startOf('day');
				vm.filter.datePicker.endDate.endOf('day');
				filters.betweenTakenDate = [ dateUtil.datetime2String(vm.filter.datePicker.startDate), dateUtil.datetime2String(vm.filter.datePicker.endDate) ];
			}
		}

		planSamplingService.searchSampleInterpretBasicInfo(filters).then(function(response) {
			vm.samples.items = [];
			var s = response.getData();
			if (Array.isArray(s)) {
				s.forEach(function(sa) {
					sa.takenDate = dateUtil.formatMomentDateTime(sa.takenDate);
					if (!isSampleSelected(sa.id))
						vm.samples.items.push(sa)
				});
			}

			// si se filtro por número de muestra y no se ha selecionado cliente
			// ni plan
			if (vm.filter.idSample && vm.samples.items.length > 0) {
				if (isEmpty(vm.filter.client) || isEmpty(vm.filter.client.selected)) {
					vm.filter.client.selected = [ s[0].client ];
					vm.filter.planSampling.selected = [ s[0].planSampling ];
					vm.filter.site.selected = [ s[0].site ];
				}
			}
			
			vm.showFiltersSamples = true;
		}, function(reponse) {
		});
	}
	
	vm.onSearch = function(item){
		vm.filter.client.selected = [];
		vm.filter.planSampling.selected = []
		vm.filter.client.selected.push(item.client);
		vm.filter.planSampling.selected.push(item.planSampling);
		vm.isCollapsed = false;
		searchSamples();
	}

	/**
	 * dnd-dragging determines what data gets serialized and send to the
	 * receiver of the drop. While we usually just send a single object, we send
	 * the array of all selected items here.
	 */
	vm.getSelectedItemsIncluding = function(list, item) {
		item.selected = true;
		return list.items.filter(function(item) {
			return item.selected;
		});
	};

	/**
	 * We set the list into dragging state, meaning the items that are being
	 * dragged are hidden. We also use the HTML5 API directly to set a custom
	 * image, since otherwise only the one item that the user actually dragged
	 * would be shown as drag image.
	 */
	vm.onDragstart = function(list, event) {
		var itemsSelected = list.items.filter(function(item) {
			return item.selected;
		});
		list.dragging = true;
		if (event.dataTransfer.setDragImage && itemsSelected.length > 1) {
			var rainbow = toggleImage(true);
			event.dataTransfer.setDragImage(rainbow, 0, 0);
		}
	};

	/**
	 * Se desahabilita la imagea mostrar se desactiav el dragging de los
	 * elementos de la list
	 */
	vm.onDragend = function(event) {
		event.dragging = false;
		toggleImage(false);
		closeAllTooltip();
	};

	/**
	 * In the dnd-drop callback, we now have to handle the data array that we
	 * sent above. We handle the insertion into the list ourselves. By returning
	 * true, the dnd-list directive won't do the insertion itself.
	 */
	vm.onDrop = function(list, items, index) {
		angular.forEach(items, function(item) {
			item.selected = false;
		});
		list.items = list.items.slice(0, index).concat(items).concat(list.items.slice(index));
		return true;
	}
	/**
	 * Last but not least, we have to remove the previously dragged items in the
	 * dnd-moved callback.
	 */
	vm.onMoved = function(list) {
		list.items = list.items.filter(function(item) {
			return !item.selected;
		});
	};
	/*
	 * se puede selecionar los otros filtros
	 */
	vm.isClientPlanSelected = function() {
		return vm.isClientSelected() || vm.isPlanSelected();
	}
	/*
	 * hay cliente selecionado
	 */
	vm.isClientSelected = function() {
		return isEmpty(vm.filter.client) || isEmpty(vm.filter.client.selected);
	}
	/*
	 * hay plan de muestreo seleccionado
	 */
	vm.isPlanSelected = function() {
		return isEmpty(vm.filter.planSampling) || isEmpty(vm.filter.planSampling.selected);
	}
	/*
	 * Tiene muestras selecionadas
	 */
	vm.hasSamplesSelected = function() {
		return vm.samplesSelected.items.length > 0;
	}
	/*
	 * selecciona todas las muestras que hayan sido selecionadas por el usuario
	 */
	vm.selectSelected = function(listSource, listTarget) {
		var samplesS = getItemsSelected(listSource);
		if (samplesS.length <= 0)
			return;
		$scope.onDrop(listTarget, samplesS, 0);
		removeItems(listSource, samplesS);
	}
	/*
	 * selecciona todas las muestras disponibles
	 */
	vm.selectAll = function(listSource, listTarget) {
		$scope.onDrop(listTarget, listSource.items, 0);
		listSource.items = [];
	}
	/*
	 * Se utiliza esta funcion para moder mostrar el ícono de copiar cuando se
	 * está haciendo el drag and drop toca utilizar este "truco" para que nos
	 * deje cargar una imágen a partor de un etiqueda <i>
	 */
	function toggleImage(active) {
		var rainbow = document.getElementById("dragImage");
		if (active) {
			rainbow.className = "fa fa-clone fa-5x";
			vm.isDragging = true;
		} else {
			rainbow.className = "";
			vm.isDragging = false;
		}
		return rainbow;
	}
	/*
	 * cierra todos los qtip que se esten mostrando
	 */
	function closeAllTooltip() {
		$('div.qtip:visible').qtip('hide');
	}
	/*
	 * el id esta en la lista de selccionados?
	 */
	function isSampleSelected(id) {
		return vm.samplesSelected.items.some(function(ss) {
			return ss.id === id
		});
	}

	/*
	 * Devuelve las muestras selecionadas de una lista
	 */
	function getItemsSelected(list) {
		return list.items.filter(function(item) {
			return item.selected;
		});
	}
	/*
	 * Borra las muestras de una lista
	 */
	function removeItems(list, items) {
		items.forEach(function(i) {
			var idx = getIndex(list, i.id);
			if (idx >= 0) {
				list.items.splice(idx, 1);
			}
		});
	}
	/*
	 * obtiene el indirce de una muestra en una lista
	 */
	function getIndex(list, id) {
		return list.items.findIndex(function(i) {
			return i.id == id;
		});
	}

	function init() {
		vm.samplesToBeInterpreted = [];
		planSamplingService.getSamplesToBeInterpreted().then(function(response) {
			var result = response.getData();
			if (Array.isArray(result)) {
				vm.samplesToBeInterpreted = result.map(function(s) {
					return s;
				});
			}
		}, function() {
		});
	}

	init();
}